import { render, staticRenderFns } from "./EmployeeSearch.vue?vue&type=template&id=71ffb0ae&scoped=true&"
import script from "./EmployeeSearch.vue?vue&type=script&lang=js&"
export * from "./EmployeeSearch.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeSearch.vue?vue&type=style&index=0&id=71ffb0ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ffb0ae",
  null
  
)

export default component.exports